export default __webpack_public_path__ + "static/media/banner4.13df8ded.jpg";